:host {
  display: block;
  .text-lighter {
    color: var(--gray-600);
  }
  .selectedFilterCount {
    display:flex;
    flex:1;
  }
  .fw-normal {
    font-weight: normal;
  }
  .sub-header {
    font-size: .75rem;
    margin-bottom: 1rem;
    p {
      margin: 0;
    }
    a {
      text-decoration: none;
      color: var(--primary);
      &:visited {
        color: var(--primary)
      }
    }
  }

  .filter-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .text-light{
    color: var(--text-light-gray) !important;
  }
  .filter-group {
    border-bottom: 1px solid var(--gray-300);

    &.border-top {
      border-top: 1px solid var(--gray-300);
    }
  }

  .filter-group-toggle {
    font-family: var(--font-family-sans-serif);
    border: none;
    background-color: transparent;

    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;

    padding: .75rem 1.25rem;

    font-size: 15px;
    font-weight: bold;
    cursor: pointer;

    color: var(--black);

    &.border-top {
      border-top: 1px solid var(--gray-300);
    }

    &[aria-expanded="true"] {
      icon-chevron-down {
        transform: rotate(-180deg);
      }
    }

    &:hover {
      background-color: var(--gray-200);
    }
  }

  .filter-group-options {
    display: flex;
    flex-wrap: wrap;
    padding: .75rem 1.25rem;
  }

  .filter-group-option {
    width: 100%;
    font-size: 16px;

    @media (max-width: 992px) {
      flex-basis: 50%;
      width: 50%;
    }

    @media (max-width: 576px) {
      flex-basis: 100%;
      width: 100%;
    }

    margin-bottom: 6px;

    label {
      display: flex;
      align-items: flex-start;

      input {
        opacity: 0;
        width: 0px;
        overflow: hidden;
        font-size: 1rem;

        &+i {
          color: var(--gray-500);
        }

        &:checked+i {
          color: var(--primary);
        }
      }

      i {
        margin-top: 4px;
        line-height: 0;
        margin-right: 8px;
      }
    }
  }

  .buttons {
    text-align: center;
    margin-top: 32px;

    button {
      font-family: var(--font-family-sans-serif);
      font-size: 14px;

      display: inline-flex;
      align-items: center;

      background-color: var(--primary);
      border: 1px solid var(--primary);

      color: var(--white);

      padding: .75rem 1rem;
      border-radius: 0;

      cursor: pointer;

      span {
        margin-right: 48px;
      }

      &:hover {
        opacity: .95;
      }
    }

    @media (max-width: 767.99px) {
      button {
        display: flex;
        width: 100%;
        justify-content: space-between;
      }
    }
  }
}